export enum MapLayer {
  BEACON = 'ngage-beacon',
  EXHIBIT = 'ngage-exhibit',
  FACILITY = 'ngage-facility',
  SITE = 'ngage-site',
  TRAIL = 'ngage-trail',
  ZONE = 'ngage-zone',
  BUILDING = 'ngage-building',
  INTERACTION_AREA = 'ngage-interaction-area',
}